import React, { ReactNode, isValidElement } from "react";
import { isArray } from "lodash";
import { IRoleName } from "store/types";
import { useUserRoleSelector } from "store";

interface Props {
  availableRoles: IRoleName | IRoleName[];
  children: ReactNode;
  forceDisableClick?: boolean;
}

export const ActionRoleGuard: React.FC<Props> = ({ availableRoles, children, forceDisableClick }) => {
  const role = useUserRoleSelector();
  const { name } = role || {};
  // Recursively disable onClick for all children if not admin
  const disableOnClick = (child: ReactNode): ReactNode => {
    if (isValidElement(child)) {
      const childProps: Record<string, any> = {};

      if (
        forceDisableClick ||
        (child.props.onClick && typeof availableRoles === "string" && name !== availableRoles) ||
        (child.props.onClick && name && isArray(availableRoles) && !availableRoles.includes(name))
      ) {
        // Disable the onClick handler if role is limited TM
        childProps.onClick = (e: React.MouseEvent) => e.preventDefault();
        childProps.style = { ...child.props.style, cursor: "default", pointerEvents: "none" };
      }

      const updatedChildren: React.ReactNode = React.Children.map(child.props.children, disableOnClick);

      return React.cloneElement(child, childProps, updatedChildren);
    }

    return child;
  };

  return <>{React.Children.map(children, disableOnClick)}</>;
};
